import {
  SUBMIT_IN_STORE_CREDIT_REQUEST,
  SUBMIT_IN_STORE_CREDIT_REQUEST_SUCCESS,
  SUBMIT_IN_STORE_CREDIT_REQUEST_FAILURE,
  SUBMIT_ONLINE_CREDIT_REQUEST,
  SUBMIT_ONLINE_CREDIT_REQUEST_SUCCESS,
  SUBMIT_ONLINE_CREDIT_REQUEST_FAILURE,
  GET_LOAN_SIMULATION,
  GET_LOAN_SIMULATION_SUCCESS,
  GET_LOAN_SIMULATION_FAILURE,
} from "@store/financing-solutions/constants";

import { makeApiCall } from "@lib/api/helpers";
import {
  submitInStoreCreditRequestApi,
  submitOnlineCreditRequestApi,
  getLoanSimulationApi,
} from "@lib/api";

export const submitInStoreCreditRequest = (values) => (dispatch, getState) => {
  return makeApiCall({
    actions: {
      action: SUBMIT_IN_STORE_CREDIT_REQUEST,
      success: SUBMIT_IN_STORE_CREDIT_REQUEST_SUCCESS,
      fail: SUBMIT_IN_STORE_CREDIT_REQUEST_FAILURE,
    },

    dispatch,
    getState,
    spinner: false,
    spinnerMessage: `Se trimite cererea...`,
    alert: true,
    alertMessage: `Error sending request`,

    apiCall: submitInStoreCreditRequestApi,
    apiArgs: [values],

    formatResponse: (response) => response.data,
    returnResponse: true,
  });
};

export const submitOnlineCreditRequest = (values) => (dispatch, getState) => {
  return makeApiCall({
    actions: {
      action: SUBMIT_ONLINE_CREDIT_REQUEST,
      success: SUBMIT_ONLINE_CREDIT_REQUEST_SUCCESS,
      fail: SUBMIT_ONLINE_CREDIT_REQUEST_FAILURE,
    },

    dispatch,
    getState,
    spinner: false,
    spinnerMessage: `Se trimite cererea...`,
    alert: true,
    alertMessage: `Eroare la trimiterea solicitarii`,

    apiCall: submitOnlineCreditRequestApi,
    apiArgs: [values],

    formatResponse: (response) => response.data,
    returnResponse: true,
  });
};

export const getLoanSimulation = (values) => (dispatch, getState) => {
  return makeApiCall({
    actions: {
      action: GET_LOAN_SIMULATION,
      success: GET_LOAN_SIMULATION_SUCCESS,
      fail: GET_LOAN_SIMULATION_FAILURE,
    },

    dispatch,
    getState,
    spinner: false,
    spinnerMessage: `Se trimite cererea...`,
    alert: false,
    alertMessage: `Eroare la trimiterea solicitarii`,

    apiCall: getLoanSimulationApi,
    apiArgs: [values],

    formatResponse: (response) => response.data,
    returnResponse: true,
  });
};
